<template>
  <v-container>
    <v-row>
      <Tabs
        :tabs="tabs"
        :level="2"
        :tab-lv1-index="tabLv1Index"
        :tabs-lv1-count="tabsLv1Count"
      />
    </v-row>
  </v-container>
</template>

<script>
import Tabs from '../../../components/Reporting/Tabs';
import Overview from './Overview';

export default {
  name: 'AcrewReporting',
  components: {
    Tabs,
    Overview,
  },
  props: ['tabLv1Index', 'tabsLv1Count'],
  data() {
    return {
      pageName: 'Acrew Overview',
      tabs: [
        { label: 'Overview', section: Overview },
      ],
    };
  },
};
</script>
